/** Fallback page for unknown routes. */

import { Link } from 'react-router-dom';
import '../styles/Console.css';
import '../styles/NotFoundPage.css';

export default function NotFoundPage() {
  return (
    <main className="nsc-standalone">
      <div className="nsc-card nsc-not-found">
        <span className="nsc-brand__mark" aria-hidden="true">NS</span>
        <p className="nsc-eyebrow">Error 404</p>
        <h1 className="nsc-h1">Page not found</h1>
        <p className="nsc-subtitle">That address does not match any page.</p>
        <Link className="nsc-button nsc-button--primary" to="/">
          Return to the start
        </Link>
      </div>
    </main>
  );
}
